import * as React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import { ProductFilterSettingsModel } from '../../models/product/productFilterSettingsModel';
import CategoryService from '../../services/categoriesService';
import { CategoryModel } from '../../models/category/categoryModel';
import { TreeNodeModel } from '../../models/treeNodeModel';
import { Tree } from 'primereact/tree'
import Translate from "../../common/functions/translate";
import Paper from '@material-ui/core/Paper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare, faMinusSquare } from '@fortawesome/free-regular-svg-icons';
import Snackbar from "../../common/components/snackbar/snackbar";

interface IProps {
  currentCategoryId?: number;
  onCategoryClick: any;
}

interface IState {
  validationMessage: string,
  isLoading: boolean;
  error: any;
  productSettings: ProductFilterSettingsModel,
  filterText: string,
  categories: Array<CategoryModel>;
  treeCategories: Array<TreeNodeModel>;
  selectionKeys: any;
  expandedKeys: any;
  selectedCategoryIds: Array<number>;
  selectedCategoryId?: number,
  //expanded: boolean
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: 200
      },
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '90% !important',

      },
      paperFullWidth: {
        minHeight: '400px',
        maxHeight: '400px',
        width: '40%'
      }
    },
  },
  palette: {
    primary: blue
  }
});

export class CategoryTreeFilter extends React.Component<IProps, IState>  {
  snackbar: any;
  categoryService = new CategoryService();

  constructor(props) {
    super(props);
    this.state = {
      //expanded: false,
      isLoading: false,
      validationMessage: '',
      error: null,
      productSettings: new ProductFilterSettingsModel(),
      filterText: '',
      categories: new Array<CategoryModel>(0),
      treeCategories: new Array<TreeNodeModel>(0),
      selectedCategoryIds: new Array<number>(0),
      selectionKeys: null,
      expandedKeys: null,
      selectedCategoryId: this.props.currentCategoryId,
    };
  }

  componentDidMount() {
    this.getAllCategories();
    //this.initCategoryTree();
  }

  getAllCategories() {
    this.setState({
      isLoading: true
    });

    this.categoryService.getAllCategories().then(
      (data: any) => {
        this.setState({
          categories: data,
          //isLoading: false,
        });
        this.initCategoryTree();
      })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  initCategoryTree() {
    //this.setState({ isLoading: true });
    this.createTree();
    this.showSelectedCategory(this.state.selectedCategoryId);
    this.setState({ isLoading: false });
  }

  createTree() {
    let subTree = this.createSubTree(null);
    this.setState({
      treeCategories: subTree
    });
  }

  createSubTree(parentId) {
    let subTree = new Array<TreeNodeModel>(0);

    this.state.categories
      .filter(f => parentId ? f.parentId === parentId : f.parentId === null)
      .sort((a, b) => (a.orderNo > b.orderNo) ? 1 : (b.orderNo > a.orderNo ? -1 : 0))
      .map(f => {
        let node = new TreeNodeModel();
        node.key = f.id.toString();
        node.label = f.name;
        node.data = { ...f };
        if (this.state.categories.some(a => a.parentId === f.id)) {
          node.children = this.createSubTree(f.id);
        };

        subTree.push(node);
        return 0;
      });

    return subTree;
  }

  showSelectedCategory = (categoryId) => {
    if (!categoryId) {
      this.expandMainParents({});
      //return;
    }

    let selectedCategory = this.state.categories.find(p => p.id === categoryId);
    if (!selectedCategory)
      return;

    this.expandParentNodes(selectedCategory, this.state.expandedKeys);

    this.handleSelectionChange(selectedCategory.id.toString());
  }

  expandMainParents = (expandedKeys) => {
    expandedKeys = expandedKeys ? expandedKeys : {};

    let mainCategories = this.state.categories.filter(p => p.parentId === null);
    if (mainCategories && mainCategories.length > 0) {
      mainCategories.forEach(c => {
        expandedKeys[c.id.toString()] = true;
      })
      this.setState({ expandedKeys: expandedKeys });
    }
  }

  expandParentNodes = (category: CategoryModel, expandedKeys) => {
    expandedKeys = expandedKeys ? expandedKeys : {};

    let expandedParent = this.state.categories.find(p => p.id === category.parentId);
    if (expandedParent) {
      expandedKeys[expandedParent.id.toString()] = true;
      this.expandParentNodes(expandedParent, expandedKeys);
    }

    this.setState({ expandedKeys: expandedKeys });
  }

  handleSelectionChange = (value) => {
    let categoryIds = new Array<number>(0);
    if (this.state.selectedCategoryIds.some(v => v === value)) {
      value = null;
      categoryIds = new Array<number>(0);
    } else {
      categoryIds.push(+value);
    }
    this.setState({
      selectionKeys: value,
      selectedCategoryIds: categoryIds.slice()
    });

    let categoryFilterLabel = this.returnCategoryLabel(+value, '');

    this.props.onCategoryClick(value, categoryFilterLabel);
  }

  returnCategoryLabel = (id, label) => {
    let category = this.state.categories.find(c => c.id === id);
    if (category) {

      if (label)
        label = category.name + " / " + label;
      else
        label = category.name;

      label = this.returnCategoryLabel(category.parentId, label);
    }

    return label;
  }

  nodeTemplate(node) {
    if (node.data.levelNo === 1) {
      if (!node.data.isActive)
        return (
          <b style={{ opacity: 0.5 }}>{node.label}</b>
        )

      return (
        <b>{node.label}</b>
      )
    }

    if (!node.data.isActive) {
      return (
        <div style={{ opacity: 0.5 }}>{node.label}</div>
      )
    }

    return (
      <>{node.label}</>
    )
  }

  handleExpandClick = () => {
    let expandedKeys = {};

    this.state.categories.forEach(c => {
      expandedKeys[c.id.toString()] = true;
    });

    this.setState({
      expandedKeys: expandedKeys
    });

  }

  handleCollapseClick = () => {
    this.setState({
      expandedKeys: {}
    });
  }

  render() {
    const { treeCategories, selectionKeys, expandedKeys } = this.state;

    return (
      <MuiThemeProvider theme={theme}>
        <Paper style={{ padding: 10, backgroundColor: "#f5f5f5" }} >
          <Snackbar ref={(el) => this.snackbar = el} />
          <div style={{ marginBottom: 15, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {Translate("Categories")}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ marginLeft: 5, cursor: "pointer" }}
                onClick={() => this.handleExpandClick()}
              >
                <FontAwesomeIcon
                  icon={faPlusSquare}
                  style={{ color: '#9e9e9e', fontSize: '1.5em' }}
                />
              </div>
              <div style={{ marginLeft: 5, cursor: "pointer" }}
                onClick={() => this.handleCollapseClick()}
              >
                <FontAwesomeIcon
                  icon={faMinusSquare}
                  style={{ color: '#9e9e9e', fontSize: '1.5em' }}
                />
              </div>
            </div>
          </div>

          <Tree
            value={treeCategories}
            style={{ width: "100%" }}
            selectionMode="single"
            selectionKeys={this.props.currentCategoryId ? selectionKeys : {}}
            expandedKeys={expandedKeys}
            onToggle={e => this.setState({ expandedKeys: e.value })}
            onSelectionChange={e => this.handleSelectionChange(e.value)}
            nodeTemplate={this.nodeTemplate}
          />

        </Paper>
      </MuiThemeProvider>

    )
  }
}

export default CategoryTreeFilter;
